import React from 'react'
import { useTranslation } from 'react-i18next'
import {observer} from 'mobx-react'
import {IconTitle} from '@/components'
import {Form, message, Select} from 'antd'
import {getFilterTransactionTypes} from '@/utils/transactions'
import {TransactionType} from '@/types/transactions'
import {TransactionTypeFormFieldProps} from './props'
import styles from './styles.scss'
import {SELECT_TRANSACTION_TYPE, TRANSACTION_ITEM} from '@/constants/playwright-ids'

export const TransactionTypeFormField: React.FC<TransactionTypeFormFieldProps> = observer((
    {form, formItemProps, name = 'transactionType', transactionTypes = getFilterTransactionTypes()}
) => {
    const { t } = useTranslation()
    return <Form.Item
        name={name}
        label={
            <IconTitle
                title={t('TransactionTypeFormField.labels.transactionType')}
                tooltipText={(
                    <ul className={styles.tooltipList}>
                        {transactionTypes
                            .map(({value}) => <li key={value}>{t(`enums:transactionTypesTooltip.${value}`, { defaultValue: value })}</li>)}
                    </ul>
                )}
            />
        }
        rules={[{ required: true, message: t('TransactionTypeFormField.errors.transactionType') }]}
        {...formItemProps}
    >
        <Select
            data-test-id={SELECT_TRANSACTION_TYPE}
            placeholder={t('TransactionTypeFormField.placeholders.transactionType')}
            onChange={(v) => {
                if (v === TransactionType.VERIFICATION) {
                    if (form.getFieldValue('amount')) {
                        message.destroy(t('TransactionTypeFormField.warnings.verification'))
                    }
                    form.setFieldsValue({ amount: 0 })
                }
            }}
        >
            {transactionTypes.map((item) => (
                <Select.Option
                    key={item.value}
                    value={item.value}
                    data-test-id={TRANSACTION_ITEM + item.value}
                >
                    {item.label}
                </Select.Option>
            ))}
        </Select>
    </Form.Item>
})
